import { render } from "./LotteryRule.vue?vue&type=template&id=65c44a44&bindings={}"
import script from "./LotteryRule.vue?vue&type=script&lang=ts"
export * from "./LotteryRule.vue?vue&type=script&lang=ts"

import "./LotteryRule.vue?vue&type=style&index=0&lang=less"
script.render = render

export default script